import StudyItem from './StudyItem';
export default StudyItem;
